import { Routes, Route } from 'react-router-dom';
import SiteLayout from './layouts/SiteLayout.jsx';
import Home from './pages/Home.jsx';
import Impressum from './pages/Impressum.jsx';
import Datenschutz from './pages/Datenschutz.jsx';
import Danke from './pages/Danke.jsx';
import NotFound from './pages/NotFound.jsx';
import { ROUTES } from './routes.js';

// Zentrale Route-Definition.
// Alle öffentlichen Seiten teilen sich SiteLayout (Nav + Footer).
// Spätere geschützte Bereiche können parallel dazu mit eigenem Layout ergänzt werden.
export default function App() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path={ROUTES.home} element={<Home />} />
        <Route path={ROUTES.impressum} element={<Impressum />} />
        <Route path={ROUTES.datenschutz} element={<Datenschutz />} />
        <Route path={ROUTES.danke} element={<Danke />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
